package com.swetdot.swetgram.data.notifications

import com.swetdot.swetgram.data.api.ApiClient
import com.swetdot.swetgram.domain.NotificationPreferences
import com.swetdot.swetgram.protocol.dto.NotificationSettings
import io.ktor.client.request.setBody

class NotificationSettingsRepository(private val api: ApiClient) {
    suspend fun get(): NotificationPreferences =
        api.get<NotificationSettings>("users/me/notification-settings").toDomain()

    suspend fun update(preferences: NotificationPreferences): NotificationPreferences =
        api.patch<NotificationSettings>("users/me/notification-settings") {
            setBody(preferences.toDto())
        }.toDomain()
}

private fun NotificationSettings.toDomain() = NotificationPreferences(
    messages = messages,
    groups = groups,
    discover = discover,
    mentions = mentions,
    security = security,
    showMessagePreview = showMessagePreview,
    showDiscoverCommentPreview = showDiscoverCommentPreview,
    mutedChatMentions = mutedChatMentions,
    streaks = streaks,
)

private fun NotificationPreferences.toDto() = NotificationSettings(
    messages = messages,
    groups = groups,
    discover = discover,
    mentions = mentions,
    security = true,
    showMessagePreview = showMessagePreview,
    showDiscoverCommentPreview = showDiscoverCommentPreview,
    mutedChatMentions = true,
    streaks = streaks,
)
